import { render, staticRenderFns } from "./SurveyPage.vue?vue&type=template&id=6cb7639c&scoped=true&"
import script from "./SurveyPage.vue?vue&type=script&lang=js&"
export * from "./SurveyPage.vue?vue&type=script&lang=js&"
import style0 from "./SurveyPage.vue?vue&type=style&index=0&id=6cb7639c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb7639c",
  null
  
)

export default component.exports